const BrandList = () =>
  import(/* webpackChunkName: "BrandList" */ 'src/components/Dashboard/Views/Brands/BrandList.vue');

const BrandEdit = () =>
  import(/* webpackChunkName: "BrandEdit" */ 'src/components/Dashboard/Views/Brands/BrandEdit.vue');

export const brandRoutes = [
  {
    path: 'brands/add/',
    name: 'Create Brand',
    component: BrandEdit,
  },
  {
    path: 'brands/edit/:id',
    name: 'Edit Brand',
    component: BrandEdit,
  },
  {
    path: 'brands/list/',
    name: 'List Brands',
    component: BrandList,
  },
];
